"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableProptypes = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var TableProptypes = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    translation: _propTypes.default.shape({
      adult: _propTypes.default.string,
      infant: _propTypes.default.string,
      child: _propTypes.default.string,
      guestName: _propTypes.default.string,
      bookingNumber: _propTypes.default.string,
      cabin: _propTypes.default.string,
      checked: _propTypes.default.string
    }),
    columns: _propTypes.default.arrayOf(_propTypes.default.shape({
      columnName: _propTypes.default.string,
      columnKey: _propTypes.default.string
    })).isRequired,
    data: _propTypes.default.arrayOf(_propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape((0, _defineProperty2.default)({}, _propTypes.default.string, _propTypes.default.object || _propTypes.default.string)), _propTypes.default.array, _propTypes.default.bool]))).isRequired,
    withSubLabel: _propTypes.default.bool,
    isMobile: _propTypes.default.bool,
    isEllipsis: _propTypes.default.bool,
    ellipsisLength: _propTypes.default.string,
    rowsWithAction: _propTypes.default.bool,
    dropdownOptionsProps: _propTypes.default.object,
    onOptionSelect: _propTypes.default.func,
    boxSizing: _propTypes.default.bool,
    showBorder: _propTypes.default.bool,
    isTableFixed: _propTypes.default.bool,
    headerProperties: _propTypes.default.object,
    contentProperties: _propTypes.default.object,
    subheaderProperties: _propTypes.default.object
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    translation: _objectSpread({}, _constant2.TRANSLATION),
    columns: [],
    data: [],
    withSubLabel: false,
    isMobile: false,
    isEllipsis: false,
    ellipsisLength: null,
    rowsWithAction: false,
    dropdownOptionsProps: null,
    onOptionSelect: function ref() {},
    showBorder: true,
    boxSizing: false,
    isTableFixed: false,
    headerProperties: {},
    contentProperties: {},
    subheaderProperties: {}
  }
};
exports.TableProptypes = TableProptypes;